import { Link } from "react-router-dom";
import { ArrowRight, Home } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFoundPage() {
  usePageMeta(
    "Pagina nu a fost găsită - Ordell WebCare",
    "Pagina pe care o căutați nu există sau a fost mutată."
  );

  return (
    <section data-testid="not-found-page" className="py-28 lg:py-40">
      <div className="section-container text-center max-w-2xl mx-auto">
        <p className="font-['Outfit'] text-8xl lg:text-9xl font-bold text-[#0F2942]/10 mb-4">404</p>
        <h1 className="font-['Outfit'] text-2xl sm:text-3xl lg:text-4xl tracking-tight font-semibold text-[#1A1D20] mb-4">
          Pagina nu a fost găsită
        </h1>
        <p className="text-[#4A5568] leading-relaxed mb-8">
          Pagina pe care o căutați nu există, a fost mutată sau adresa nu este corectă. Verificați link-ul sau navigați înapoi către pagina principală.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="404-home-btn"
            className="inline-flex items-center justify-center gap-2 bg-[#0F2942] text-white font-medium px-6 py-3 rounded-xl hover:bg-[#0F2942]/90 transition-all"
          >
            <Home className="w-4 h-4" /> Înapoi la pagina principală
          </Link>
          <Link
            to="/contact"
            data-testid="404-contact-btn"
            className="inline-flex items-center justify-center gap-2 bg-white text-[#0F2942] border border-[#0F2942]/10 font-medium px-6 py-3 rounded-xl hover:bg-[#F0F5F4] transition-all"
          >
            Contactează-ne <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
